import { useIntl } from 'react-intl'

import { useAppSelector } from 'app/hooks'
import { formatTime } from 'app/utils/formatDate'
import { activeSubscriptionSelector } from 'features/home/selectors'
import { subscriptionUpdateMessages } from '../../messages'

import {
  NextBillingDateLabel,
  NextBillingDateWrapper,
  PlanNameLabel,
  PlanPriceLabel,
  RightPanelBlock,
  RightPanelBottomLine,
  RightPanelPlanWrapper,
  TotalToPayLabel,
  TotalToPayPriceLabel,
} from '../styles'

import { subscriptionManagementMessages } from '../../../SubscriptionManagement/messages'
import { RightPanelBottomText } from '../../../SubscriptionManagement/SubsManageRightPanel/styles'

interface UpdatePlanBlockProps {
  selectedPlanName: string
  selectedPlanPrice: string
}
function UpdatePlanBlock({
  selectedPlanName,
  selectedPlanPrice,
}: UpdatePlanBlockProps) {
  const { formatMessage } = useIntl()
  const activeSubscription = useAppSelector(activeSubscriptionSelector.data)
  const periodEnd =
    activeSubscription.licenseExpiresAt ??
    activeSubscription.current_period_end * 1000
  return (
    <>
      <RightPanelPlanWrapper>
        <RightPanelBlock>
          <PlanNameLabel>{selectedPlanName}</PlanNameLabel>
        </RightPanelBlock>

        <RightPanelBlock>
          <PlanPriceLabel>{selectedPlanPrice}</PlanPriceLabel>
        </RightPanelBlock>
      </RightPanelPlanWrapper>

      <RightPanelBottomLine />

      <RightPanelPlanWrapper>
        <RightPanelBlock>
          <TotalToPayLabel>
            {formatMessage(subscriptionUpdateMessages.totalForSubscription)}
          </TotalToPayLabel>
        </RightPanelBlock>
        <RightPanelBlock>
          <TotalToPayPriceLabel>$0</TotalToPayPriceLabel>
        </RightPanelBlock>
      </RightPanelPlanWrapper>

      <RightPanelBottomLine />

      <NextBillingDateWrapper>
        <RightPanelBlock>
          <NextBillingDateLabel>
            {formatMessage(subscriptionManagementMessages.nextBillingDateLabel)}
          </NextBillingDateLabel>
        </RightPanelBlock>

        <RightPanelBlock>
          <NextBillingDateLabel>
            <b>{formatTime(periodEnd)}</b>
          </NextBillingDateLabel>
        </RightPanelBlock>
      </NextBillingDateWrapper>
      <RightPanelBottomText>
        {formatMessage(subscriptionManagementMessages.upgradePlanBottomText)}
      </RightPanelBottomText>
    </>
  )
}

export default UpdatePlanBlock
